import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { AlertDropDown, FormatPrice, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ShippingCost = ({ currency, total, base, duties, tax, currencyAdjustment, handlingFees }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hasHandlingFees = Number(handlingFees) > 0

  return (
    <Styles.MainContainer>
      <Styles.TotalContainer>
        <Text type="bodyMBold" color={theme.colors.info.hover}>
          {t('Total envío')}:
        </Text>
        <Text type="bodyMBold" color={theme.colors.info.hover}>
          <FormatPrice currency={currency}>{total}</FormatPrice>
        </Text>
      </Styles.TotalContainer>
      <AlertDropDown
        options={{ withIcon: false, titleStyle: 'bodyMBold', backgroundColor: theme.colors.background.secondary }}
        title={t('Mostrar desglose')}
        titleWhenIsOpen={t('Ocultar desglose')}
      >
        <Styles.CostsContainer>
          <Styles.CostLine>
            <Text type="bodyMBold">{t('Coste base')}</Text>
            <Text type="bodyMBold">
              <FormatPrice currency={currency}>{base}</FormatPrice>
            </Text>
          </Styles.CostLine>
          <Styles.CostLine>
            <Text type="bodyMBold">{t('Aranceles')}</Text>
            <Text type="bodyMBold">
              <FormatPrice currency={currency}>{duties}</FormatPrice>
            </Text>
          </Styles.CostLine>
          <Styles.CostLine>
            <Text type="bodyMBold">{t('Ajuste por tipo de cambio')}</Text>
            <Text type="bodyMBold">
              <FormatPrice currency={currency}>{currencyAdjustment}</FormatPrice>
            </Text>
          </Styles.CostLine>

          <Styles.CostLine>
            <Text type="bodyMBold">{t('Impuestos')}</Text>
            <Text type="bodyMBold">
              <FormatPrice currency={currency}>{tax}</FormatPrice>
            </Text>
          </Styles.CostLine>
          {hasHandlingFees && (
            <Styles.CostLine>
              <Text type="bodyMBold">{t('Tasas de tramitación')}</Text>
              <Text type="bodyMBold">
                <FormatPrice currency={currency}>{handlingFees}</FormatPrice>
              </Text>
            </Styles.CostLine>
          )}
        </Styles.CostsContainer>
      </AlertDropDown>
    </Styles.MainContainer>
  )
}

export default ShippingCost
